/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Warehouse_Audit_DescriptionInputs */

const en_audit_warehouse_audit_description = /** @type {(inputs: Audit_Warehouse_Audit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physical inventory count and reconciliation`)
};

const es_audit_warehouse_audit_description = /** @type {(inputs: Audit_Warehouse_Audit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteo fisico de inventario y conciliacion`)
};

/**
* | output |
* | --- |
* | "Physical inventory count and reconciliation" |
*
* @param {Audit_Warehouse_Audit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_warehouse_audit_description = /** @type {((inputs?: Audit_Warehouse_Audit_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Warehouse_Audit_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_warehouse_audit_description(inputs)
	return es_audit_warehouse_audit_description(inputs)
});